import React, { useEffect, useState } from 'react'
import CustomDrawer from '../../controls/CustomDrawer'
import ExportButton from '../../controls/ExportButton'
import { exportToFile } from '../../controls/DataExporter'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { fetchAttendance } from '../../../api/AttendanceApi'

const OptionAttendance = ({ setDrawer,isAllowExport, filters, searchValue }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const store = useSelector((state) => state.store.store);

  useEffect(() => {
    const loadData = async () => {
      const attendanceData = await fetchData();
      setData(attendanceData);
    };
    loadData();
  }, [filters, searchValue]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetchAttendance(
        store.key,
        0,
        2000,
        filters.fromDate,
        filters.toDate,
        searchValue ? searchValue : filters.employee,
      );

      if (response.code === "0") {
        return response.attendance || [];
      } else {
        toast.error(response.message || "Error fetching attendance");
        return [];
      }
    } catch (err) {
      toast.error("Failed to fetch attendance. Please try again!");
      console.error("Error fetching attendance:", err);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const exportColumns = [
    { header: "Employee", field: "Employee.label" },
    { header: "Date", field: "Date", type: "date" },
    { header: "AttendanceType", field: "AttendanceType" },
    { header: "In Time Display", field: "inTime" },
    { header: "Out Time Display", field: "outTime" },
    { header: "Remarks", field: "Remarks" },
  ];

  const rows = data.map((item) => ({
 ...item,
  inTime: (item.AttendanceType !== "Leave" && item.AttendanceType !== "Week-Off") 
    ? `${item.InTime?.HH}.${item.InTime?.MM} ${item.InTime?.AMPM}` 
    : "",
  outTime: (item.AttendanceType !== "Leave" && item.AttendanceType !== "Week-Off") 
    ? `${item.OutTime?.HH}.${item.OutTime?.MM} ${item.OutTime?.AMPM}` 
    : "",
  }));

  const handleExport = async (type) => {
    try {
      if (rows.length === 0) {
        toast.warning("No data available to export");
        return;
      }
      
      await exportToFile({
        data: rows,
        columns: exportColumns,
        fileType: type, // 'PDF' or 'CSV'
        title: "Attendance",
        landscape: true
      });
    } catch (error) {
      toast.error(`Export failed: ${error.message}`);
      console.error("Export error:", error);
    }
  };

  return (
    <CustomDrawer
      setDrawer={setDrawer}
      title="Options"
      drawerType="small"
    >
      <div className='grid gap-5'>
        {isAllowExport && <div className='mx-auto'>
          <ExportButton
            loading={loading}
            onExport={handleExport}
          />
        </div>}
      </div>
    </CustomDrawer>
  );
}

export default OptionAttendance;